import PropTypes from "prop-types";
import React, { useState } from "react";
import NipForm from "./Form";
import PublicKeys from "../PublicKeys";
import Storage from "../../../../utils/storage";

const NipPermit = (props) => {
  const { application, runTests, ipPermitForm, getAllApplications } = props;

  const [showIp, setShowIp] = useState(false);

  const ipSubmission =
    application &&
    application.nip_trail &&
    application.nip_trail.ip_form_submission;

  const goToNext = reRoute(setShowIp);

  return (
    <div>
      {!showIp && !ipSubmission ? (
        <NipForm goToNext={goToNext} application={application} />
      ) : (
        <PublicKeys
          goToNext={runTests}
          ipPermitForm={ipPermitForm}
          application={application}
          getAllApplications={getAllApplications}
          goToPrev={ipPermitForm}
        />
      )}
    </div>
  );
};

NipPermit.propTypes = {
  application: PropTypes.any,
  getAllApplications: PropTypes.any,
  goToNext: PropTypes.any,
  ipPermitForm: PropTypes.any,
  runTests: PropTypes.any,
};

export default NipPermit;
function reRoute(setShowIp) {
  return (data) => {
    setShowIp(true);
    Storage.set("data", JSON.stringify(data));
  };
}
